// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"544c93d8","156":"89aebdd1","207":"e8589e1e","871":"4810d41e"}[chunkId] + ".chunk.css";
};